const INITIAL_STATE = {
  searchString: '',
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case 'FilterDataTable':
      return {
        ...state,
        searchString: payload,
      };

    default:
  }
  return state;
};
